import { render } from "./FormSolicitacao.vue?vue&type=template&id=7209da32"
import script from "./FormSolicitacao.vue?vue&type=script&lang=js"
export * from "./FormSolicitacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__